import { useMemo } from 'react';
import classNames from 'classnames';

import config from 'Config';

import BackgroundImage from './BackgroundImage';
import BackgroundSlides from './BackgroundSlides';

type Props = {
  isDesktop?: boolean;
};

const Background = ({ isDesktop }: Props) => {
  const background = useMemo(
    () => config.loginPage.backgroundImages[isDesktop ? 'desktop' : 'mobile'],
    [isDesktop]
  );

  return (
    <>
      {Array.isArray(background) && background.length > 1 ? (
        <BackgroundSlides backgroundImages={background} />
      ) : (
        <BackgroundImage className="Bga(f)--ml" sources={background} />
      )}
      <div
        className={classNames(
          'StretchedBox Bgc(#000.2)--s Bgc(#000.4)--ml StretchedBox::b Cnt($blank)::b',
          {
            'Bgi($top-dark-fade-large)::b Bga(f)::b': isDesktop,
            'Bgi($top-dark-fade-small)::b Bgi($bottom-dark-fade)::a StretchedBox::a Cnt($blank)::a':
              !isDesktop,
          }
        )}
      />
    </>
  );
};

Background.defaultProps = {
  isDesktop: false,
};

export default Background;
